//REGISTER
export const POST_FAKE_REGISTER = '/post-fake-register';

//LOGIN
export const POST_LOGIN = '/auth/login';

export const POST_FAKE_JWT_LOGIN = '/post-jwt-login';
export const POST_FAKE_PASSWORD_FORGET = '/fake-forget-pwd';
export const POST_JWT_PASSWORD_FORGET = '/auth/forgetPassword';
export const SOCIAL_LOGIN = '/social-login';

//PROFILE
export const POST_EDIT_JWT_PROFILE = '/post-jwt-profile';
export const POST_EDIT_PROFILE = '/post-fake-profile';

//CALENDER
export const GET_EVENTS = '/events';
export const GET_CATEGORIES = '/categories';
export const GET_UPCOMMINGEVENT = '/upcommingevents';
export const ADD_NEW_EVENT = '/add/event';
export const UPDATE_EVENT = '/update/event';
export const DELETE_EVENT = '/delete/event';

//Chat
export const GET_DIRECT_CONTACT = '/chat';
export const GET_MESSAGES = '/messages';
export const ADD_MESSAGE = 'add/message';
export const GET_CHANNELS = '/channels';

//project list
export const GET_PROJECT_LIST = '/project/list';
//PRODUCTS
export const GET_PRODUCTS = '/products';
export const GET_ORDERS = '/orders';

//Task
export const GET_TASK_LIST = '/task-list';

//Crypto
export const GET_TRANSATION_LIST = '/transation-list';
export const GET_ORDRER_LIST = '/order-list';

//TicketsList
export const GET_TICKETS_LIST = '/tickets-list';

//Crm
export const GET_CONTACTS = '/crmcontacts';
export const GET_COMPANIES = '/companies';
export const GET_DEALS = '/deals';
export const GET_LEADS = '/leads';

//Invoice
export const GET_INVOICES = '/invoices';
export const GET_CUSTOMERS = '/customers';

//Menu
export const GET_MENU_ITENS = '/auth/menu';

// Types Notes
export const GET_NOTES_TYPE = '/register/customer-note-type';

// Categories Plans
export const GET_CATEGORY_PLANS = '/register/plan-category';

// Associates
export const GET_ASSOCIATES = '/customer';
export const GET_SUMMARY_ASSOCIATES = '/customer/summary';
export const GET_ORDER_ASSOCIATES = '/customer/pagination';

// Plans
export const GET_PLANS = '/register/plan';

// Category Organization
export const GET_CATEGORY_ORGANIZATION = '/register/organization-category';

// Services
export const GET_SERVICE = '/register/service';

// Sellers
export const GET_SELLERS = '/register/seller';

// Offices
export const GET_OFFICES = '/register/office';

// Cost Center
export const GET_COST_CENTER = '/register/financial-center';

// Category Finance
export const GET_FINANCE = '/register/financial-category';

// Propostas
export const GET_PROPOSAL = '/proposal';

export const GET_HISTORY_STATUS = '/proposal-event';

export const GET_KINSHIP = '/register/kinship-select';

// Organizações
export const GET_ORGANIZATIONS = '/register/organization';

// Notas de Associados
export const GET_NOTESASSOCIATES = '/register/customer-note';

export const BASE = process.env.REACT_APP_API_URL;

// Specialties
export const GET_SPECIALTIES = '/register/specialty';

// Provider Specialties
export const GET_PROVIDER_SPECIALTIES = '/register/provider-specialty';

// Units
export const GET_UNITS = '/register/unit';

// Users
export const GET_USERS = '/register/user';

// Credentials Network (NT)
export const GET_CREDENTIALSNT = '/register/provider';

// Visit Schedule
export const GET_SCHEDULE = '/register/provider-history';

// Overview
export const GET_OVERVIEW = '/overview';

// Reports
export const GET_REPORTS = '/reports';

// Accounts
export const GET_ACCOUNTS = '/register/financial-account';
export const GET_ACCOUNT_BY_ID = '/register/financial-account';
export const CREATE_ACCOUNTS = '/register/financial-account';
export const UPDATE_ACCOUNTS = '/register/financial-account';
export const DELETE_ACCOUNTS = '/register/financial-account';

// Supplier
export const GET_SUPPLIESLIST = '/register/person';

// Bills To Pay
export const GET_BILLS_TO_PAY = '/financial';

// Validation Of Proposals
export const GET_PRE_PROPOSAL = '/pre-proposal';
